import { File } from "react-feather";

let menuText = localStorage.getItem("menu")
let menuJSON = JSON.parse(menuText)
let menuList = []

if(menuJSON != null){
  let menuReport = menuJSON.filter((item) => item.label == 'Laporan')

  if (menuReport[0] !== undefined) {
    if (menuReport[0].children != undefined || menuReport[0].children != null) {
      menuReport[0].children.map((item) => {
        if (item.label == 'Laporan Kualitatif') {
          menuList.push(
            {
              id: 'lap-kualitatif',
              title: 'Laporan Kualitatif',
              navLink: '/report/kualitatif/default'
            }
          )
        } else if (item.label == 'Laporan Kuantitatif') {
          menuList.push({
            id: 'lap-kantitatif',
            title: 'Laporan Kuantitatif',
            navLink: '/report/kuantitatif/menu'
          })
        } else if (item.label == 'Laporan Rekap Total') {
          menuList.push({
            id: 'all-rekap',
            title: 'Laporan Rekap Total',
            navLink: '/report/all'
          })
        }
      })
    }
  }
}

// {
//   id: 'kejati-rekap',
//   title: 'Laporan Rekap Kejati',

//   navLink: '/report/kejati'
// }

export const laporan = [{
  id: 'laporan-head',
  title: 'Laporan',
  icon: <File size={20} />,
  children: menuList
}]
